<template>
  <div>
    <transition name="fade">
      <div v-show="focus && mask" class="lp-textarea-mask"></div>
    </transition>
    <span v-if="labelTop" class="lp-input-label font-weight-medium">
      {{ labelTop }}
      <span v-if="!preview && required" class="text-blue">*</span>
    </span>
    <span v-if="preview" class="lp-textarea-preview" :title="modelValue">
      {{ modelValue }}
    </span>
    <textarea
      v-else
      ref="textarea"
      :value="modelValue"
      :style="{ resize, 'z-index': mask ? '100' : null }"
      :disabled="disabled"
      class="lp-textarea"
      :class="[
        status && `lp-input-wrapper-${status}`,
        disabled && `lp-input-wrapper-disabled`,
      ]"
      :placeholder="placeholder"
      :rows="rows"
      @input="onInput"
      @focus="focus = true"
      @blur="focus = false"
    />
    <transition name="fade-bottom">
      <span
        v-if="message"
        class="lp-input-message mt-half d-flex"
        :class="[
          status && `lp-input-message-${status}`,
          disabled && `lp-input-message-disabled`,
        ]"
      >
        {{ message }}
      </span>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { onMounted, nextTick, ref, computed } from 'vue'

defineOptions({
  name: 'lp-textarea',
})

type Props = {
  placeholder?: string
  disabled?: boolean
  resizable?: boolean
  resizeOnWrite?: boolean
  labelTop?: string
  rows?: number
  status?: string
  message?: string
  modelValue: string
  mask?: boolean
  required?: boolean
  preview?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  placeholder: '',
  disabled: false,
  resizable: false,
  resizeOnWrite: false,
  labelTop: '',
  rows: 4,
  status: 'neutral',
  message: null,
  modelValue: null,
  mask: false,
  required: false,
  preview: false,
})
const emit = defineEmits(['update:modelValue'])
const textarea = ref()
const focus = ref(false)

const resize = computed(() => (props.resizable ? 'vertical' : 'none'))

function onInput(e: InputEvent) {
  const target = e.target as HTMLTextAreaElement
  emit('update:modelValue', target.value)

  if (props.resizeOnWrite) {
    target.style.height = 'auto'
    target.style.height = target.scrollHeight + 'px'
  }
}

onMounted(async () => {
  if (props.resizeOnWrite && textarea.value) {
    await nextTick()
    ;(textarea.value as HTMLTextAreaElement).style.height =
      (textarea.value as HTMLTextAreaElement).scrollHeight + 'px'
  }
})
</script>

<style>
textarea {
  font-family: 'Roboto', 'Helvetica Neue', sans-serif;
}
</style>
